import {format} from 'date-fns';
import {handleActions} from 'redux-actions';
import capitalize from 'capitalize';
import {getStatusColorClass} from '@pluto/ingest-validation-report/IngestReportStyle';
import {INGEST_LIST_SET} from './IngestListActions';
import {
    IngestListItem,
    IngestListItemFeed,
    IngestListReducerItem,
} from './IngestListReducerTypes';
import {IngestConfigPayloadItem} from '../../IngestConfigs/Redux/IngestConfigsReducerTypes';

export const parseEndTime = (a: string) => (a ? format(new Date(a), 'Pp') : '');

export const formatTypeName = (contentType: string) =>
    capitalize.words(contentType.replace(/_/g, ' '));

export const getContentItemNumber = ({
    data,
    contentType,
    seasonNumber,
}: IngestListItem) => {
    if (contentType === 'season')
        return {
            season: data.contentItem.number,
        };

    if (contentType === 'episode')
        return {
            episode: data.contentItem.number,
            season: seasonNumber,
        };

    return {};
};

export const formatContentTypeName = ({contentType}: IngestListItem) => {
    const name = formatTypeName(contentType);

    if (name === 'Episode') return `TV ${name}`;

    return name;
};

export const formatProviderName = ({
    provider,
}: IngestListItemFeed | IngestConfigPayloadItem) => {
    if (provider === 'bluevo') return 'BluEvo';

    if (provider === 'mrss') return 'MRSS';

    return provider;
};

export const formatStatus = ({status}: IngestListItem) => {
    const pattern = /^COMPLETE/g;

    if (pattern.test(status)) return 'COMPLETE';

    return status.replace(/_/g, ' ');
};

export const mapIngestItem = (el: IngestListItem) => {
    const title = el.seriesTitle || el.title;
    const partner = el.contentPartner?.partnerName;
    const {season, episode} = getContentItemNumber(el);
    const type = formatProviderName(el.feed);
    const status = formatStatus(el);
    const contentTypeName = formatContentTypeName(el);
    const validation = el.validationReport?.contentItemId;
    const validationStatus = el.validationReport?.validationStatus;
    const validationStatusColor = getStatusColorClass(validationStatus);
    const startDate = new Date(el.startTime);
    const startTime = format(startDate, 'Pp');
    const endTime = parseEndTime(el.endTime);
    return {
        ...el,
        title,
        partner,
        season,
        episode,
        type,
        status,
        contentTypeName,
        validation,
        validationStatus,
        validationStatusColor,
        startTime,
        endTime,
    };
};

interface State {
    rows: IngestListReducerItem[];
    total: number;
}
interface Payload {
    payload: {
        rows: IngestListItem[];
        total: number;
    };
}

export const setIngests = (state: State, {payload}: Payload) => {
    const {rows, total} = payload;

    if (rows)
        return {
            rows: rows.map(mapIngestItem),
            total,
        };

    return state;
};

const initialState = {
    rows: [],
    total: 0,
};

const handlers = {
    [INGEST_LIST_SET]: setIngests,
};

export default handleActions(handlers, initialState);
